<template>
  <div class="confirm_rakuten">
    <section class="rakuten-area">
      <button @click="closeModal" class="close_btn">
        <span class="close"></span>
      </button>
      <h2>楽天会員ログイン／楽天会員登録</h2>
      <div class="container">
        <div class="lead">
          <p>この宿泊プランのご予約には楽天の会員登録が必要になります。</p>
          <p>「楽天会員のユーザIDでログイン」ボタンを押下し認証を進めてください。</p></div>
        <button @click="isLogin">
          <img src="https://image.rakuten.co.jp/com/img/openid/openid_userlogin_M.gif" alt="">
        </button>
        <div class="back-link">
          <button @click="closeModal">
            <img
                src="https://benefitonecms.prod.acquia-sites.com/sites/default/files/travel/rakuten/img/back_btn.jpg"
                alt="戻るボタン" width="184" height="28">
          </button>
        </div>
        <ul>
          <li>
            <div class="b">※必ず下記をご確認の上、ご予約をお申込みください。</div>
            <span class="b">1.Bene楽天トラベルのご利用全般について</span>
            <div class="txt_02">
              <p>・Bene楽天トラベルは、「楽天トラベル」から定期的にデータを取得し、ベネフィット･ステーション上にご提供しております。つきましてはデータ更新のタイミングやシステムの仕様により、プランの内容や表示価格、及び空室の状況が「楽天トラベル」と相違することがございます。</p>
              <p>・Bene楽天トラベルと「楽天トラベル」の情報に不一致がある場合、お申込み完了ボタンをクリックいただいても、ご予約が成約しないことがございます。予めご了承いただきますよう、お願い申し上げます。（一例：施設基本情報のチェックアウト時間と異なる）</p>
              <p>・宿泊代金の支払い方法（キャンセル料金、予約金、その他諸税を含む）は、各宿泊施設によって異なりますので、必ずご確認ください。</p>
              <p>・ご予約が成約した際には、「RY」から始まる予約番号が発行されます。弊社ホームページ上、左記予約番号が画面上で発行されたことをご確認ください。</p></div>
          </li>
          <li>
            <span class="b">2.Bene楽天トラベルご予約申込について</span><br>
            <div class="txt_02"><p>・ベネフィット・ステーション会員専用サイト
              からのご予約のみとなり、電話でのご予約は受け付けておりません。また、楽天トラベル宿泊予約センターでの予約申し込みもできませんのでご注意ください。</p>
              <p>・お申込みには楽天会員IDが必要となります。</p>
              <p>・申込み手続き中にプラン一覧・カレンダー画面にて表示されていた宿泊料金が変更になる場合がございますが、成立した時点での料金がお客様のご利用料金となります。必ず最終申込画面にて宿泊料金をご確認の上、お申込みください。</p>
              <p>・楽天ポイントおよび楽天トラベルクーポンはご利用いただけません。（※楽天トラベルクーポンには、全国旅行支援、県民割等を含みます）。</p>
              <p>・楽天ポイントはチェックアウト日の翌日から10日後までに、ご予約時にご入力された楽天会員IDへ付与されます。なお、付与ポイント数は補助金や各種ポイントのご申請金額を除いた税抜金額から算出されます。</p>
            </div>
          </li>
          <li>
            <span class="b">3.Bene楽天トラベルの予約変更及びキャンセルについて</span>
            <div class="txt_02 pb-0">
              <p>・予約内容の変更につきましては、会員様ご自身にて一度ご予約をお取消し（キャンセル）いただき、変更後の内容にて再度お申込いただく必要がございます。なお、お取消し後にお部屋が満室となりお取り直しができなかった場合、弊社では責任を負いかねますので、予めご了承のほどお願い申し上げます。</p>
              <p>・ご予約のお取消しにつきましてはベネフィット・ステーション会員専用サイトのマイページから会員様ご自身でお手続きをお願いいたします。</p>
              <p>（ご予約時にご入力された楽天会員IDが必要となります。）</p>
              <p>・マイページ上からお取消しできない場合は、大変お手数ですが、直接施設へキャンセルのご連絡をお願いいたします。</p></div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    isLogin () {
      this.$emit("isLogin")
    },
    closeModal () {
      this.$emit("rakutenConfirm", false)
    }
  }
}
</script>
<style lang="scss" scoped>
.confirm_rakuten {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background: #000000B3;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rakuten-area {
  margin: 0 auto;
  text-align: center;
  padding: 0;
  width: 1032px;
  background: #fff;
  border-radius: 8px;
  position: relative;

  @media only screen and (max-width: 1032px){
    width: 95vw;
  }
}

.rakuten-area .container{
  height: 70vh;
  max-height: 860px;
  overflow-y: scroll;
  overscroll-behavior-y: none;
  margin-bottom: 2rem;

  @media only screen and (max-width: 1032px){
    padding: 0 1rem;
  }
}

.rakuten-area h2 {
  color: #fff;
  background: #bf0000;
  padding: 1rem 0;
  font-size: 24px;
  letter-spacing: 0.08em;
  line-height: 30px;
  font-weight: bold;
  border-radius: 8px 8px 0 0;

  @media only screen and (max-width: 1032px){
    font-size: 18px;
    line-height: 26px;
  }
}

.rakuten-area .lead {
  padding: 30px 0;
  font-size: 16px;

  @media only screen and (max-width: 1032px){
    padding: 1rem 0 1.5rem;
    font-size: 14px;
  }
}

.rakuten-area .back-link {
  padding: 15px 0;
}

.rakuten-area ul {
  max-width: 950px;
  text-align: left;
  margin: 0 auto;
}

.rakuten-area ul p {
  font-size: 16px;

  @media only screen and (max-width: 1032px){
    font-size: 14px;
  }
}

.rakuten-area .b {
  font-size: 20px;
  font-weight: bold;

  @media only screen and (max-width: 1032px){
    font-size: 16px;
  }
}

.rakuten-area .txt_02 {
  padding: 8px 0 30px 12px;

  &.pb-0{
    padding-bottom: 0;
  }
}

.rakuten-area .txt_03 {
  padding: 12px 0 0 0;
}

.close_btn{
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-100%);
}

.close_btn > .close {
  display: block;
  position: relative;
  width: 36px;
  height: 36px;

  @media only screen and (max-width: 1032px){
    width: 20px;
    height: 20px;
  }
}

.close_btn > .close::before, .close_btn > .close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 32px;
  background: #fff;

  @media only screen and (max-width: 1032px){
    width: 2px;
    height: 16px;
  }
}

.close_btn > .close::before {
  transform: translate(-50%,-50%) rotate(45deg);
}

.close_btn > .close::after {
  transform: translate(-50%,-50%) rotate(-45deg);
}
</style>